import {get} from 'lodash'

export const getAllRows = (state, pivotTableKey) => {
  return get(state, `${pivotTableKey}.data.data`, []) || []
}

export const getTotalRowCount = (state, pivotTableKey) => {
  return get(state, `${pivotTableKey}.data.count`, 0)
}

export const getAllSelectedRows = (state, pivotTableKey) => {
  return getAllRows(state, pivotTableKey).filter(row => get(row, 'selected', false) === true)
}

export const getAreAllRowsSelected = (state, pivotTableKey) => {
  return get(state, `${pivotTableKey}.areAllRowsSelected`, false)
}

export const getCanSelectRows = (state, pivotTableKey) => {
  return get(state, `${pivotTableKey}.canSelectRows`, false)
}

export const getSearch = (state, pivotTableKey) => {
  return get(state, `${pivotTableKey}.search`, {})
}

export const isPivotTableLoading = (state, pivotTableKey) => {
  return get(state, `${pivotTableKey}.data.fetching`, false)
}

export const isPivotTableLoaded = (state, pivotTableKey) => {
  return get(state, `${pivotTableKey}.data.loaded`, false)
}

export const getGroups = (state, pivotTableKey) => {
  return get(state, `${pivotTableKey}.groups`, null)
}

export const getSortColumn = (state, pivotTableKey) => {
  return get(state, `${pivotTableKey}.sortColumn`, null)
}

export const getSortDirection = (state, pivotTableKey) => {
  return get(state, `${pivotTableKey}.sortDirection`, null)
}

export const getSelectedColumns = (state, pivotTableKey) => {
  return get(state, `${pivotTableKey}.columns`, [])
}

export const isPivotTableVisible = (state, pivotTableKey) => {
  return get(state, `${pivotTableKey}.visible`, false)
}
